export default "__VITE_ASSET__Bx3$7Hn2__"